// extracted by mini-css-extract-plugin
module.exports = {"link-your-bank-text":"StripeAccountModal_link-your-bank-text__3LqEJ","stripe-account-modal-container":"StripeAccountModal_stripe-account-modal-container__3qra7"};